import { Breadcrumb } from "antd";
import _ from "lodash";
import React from "react";
import { Link } from "react-router-dom";

import ACGlobalFilterUrlButton from "ac-components/ac-global-filter-url-button/ACGlobalFilterUrlButton";

export type CrumbObjProp = {
  to: string;
  text: string;
};

export type CrumbProp = string | JSX.Element | CrumbObjProp;

type AppBreadcrumbProp = {
  crumbs: CrumbProp[];
  extra?: JSX.Element;
};

const BreadcrumbItem = Breadcrumb.Item;

export default function AppBreadcrumb({
  crumbs = [],
  extra,
}: AppBreadcrumbProp) {
  if (_.isEmpty(crumbs)) {
    return null;
  }

  const crumbsLength = crumbs.length;

  return (
    <div className="d-flex justify-content-between">
      <div className="d-flex align-items-center">
        <Breadcrumb className="app-bread-crumb">
          {crumbs.map((crumb, i) => {
            if (typeof crumb === "object") {
              crumb = crumb as CrumbObjProp;
              if ("to" in crumb && i !== crumbsLength - 1) {
                crumb = <Link to={crumb.to}>{crumb.text}</Link>;
              } else if (crumb.text) {
                crumb = crumb.text;
              }
            }

            return <BreadcrumbItem key={`crumb-${i}`}>{crumb}</BreadcrumbItem>;
          })}
        </Breadcrumb>
        <div className="p-b-xs">
          <ACGlobalFilterUrlButton />
        </div>
      </div>
      {extra}
    </div>
  );
}
